module.exports = __webpack_public_path__ + "img/framework.dcfd450b.png";